/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import {
	ContentLargeImageSection,
	CosmosComponentContextProps,
	DividerSection,
	getHero,
	getSections,
	LicenseCardsSection,
	LicenseSeatData,
} from "@cosmos/components";
import { CosmosPageLicenseFragment } from "@cosmos/hygraph-schema";

import { css } from "@panda/css";

import { TemplateProviders } from "../templates";

interface Props {
	pageData?: CosmosPageLicenseFragment;
	componentContext?: CosmosComponentContextProps;
	locale: string;
	seatsData1?: LicenseSeatData;
	seatsData2?: LicenseSeatData;
}

export const CosmosPageLicenseClient = ({
	pageData,
	locale,
	componentContext,
	seatsData1,
	seatsData2,
}: Props): React.JSX.Element => {
	return (
		<TemplateProviders componentContext={componentContext}>
			{getHero(pageData?.hero)}

			{pageData?.contentLargeImages && pageData?.contentLargeImages?.length > 0 ? (
				<div className={css({ paddingTop: "eds.dimension.96", xlDown: { paddingTop: "eds.dimension.80" } })}>
					<DividerSection />
					{pageData?.contentLargeImages?.map((section) => (
						<ContentLargeImageSection key={section.id} {...section} />
					))}
					<DividerSection />
				</div>
			) : null}

			<LicenseCardsSection pageData={pageData} locale={locale} seatsData1={seatsData1} seatsData2={seatsData2} />

			{getSections(pageData?.refSections)}
		</TemplateProviders>
	);
};
